module.exports = __webpack_public_path__ + "img/image-1.449689e1.jpeg";